import { render, staticRenderFns } from "./EnvioInformacionPantalla.vue?vue&type=template&id=35a96f91&"
import script from "./EnvioInformacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./EnvioInformacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports